import { render, staticRenderFns } from "./HistoryBaby2.vue?vue&type=template&id=3cd910b3&scoped=true"
import script from "./HistoryBaby2.vue?vue&type=script&lang=js"
export * from "./HistoryBaby2.vue?vue&type=script&lang=js"
import style0 from "./HistoryBaby2.vue?vue&type=style&index=0&id=3cd910b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd910b3",
  null
  
)

export default component.exports